import {
    useFocusEffect,
    useNavigation
} from '@react-navigation/native';
import {
    format,
    toDate
} from 'date-fns';
import React, {
    useCallback,
    useMemo,
    useState
} from 'react';
import { Platform } from 'react-native';
import ReactNativeBiometrics from 'react-native-biometrics';
import {
    CloudStorage,
    CloudStorageScope
} from 'react-native-cloud-storage';
import fs from 'react-native-fs';
import {
    useDispatch,
    useSelector
} from 'react-redux';

import actions from '../../../actions';
import { setFormValue } from '../../../actions/forms';
import {
    clearLog,
    LOG_TO_RELEASE
} from '../../../actions/logs';
import {
    BigButton,
    Page,
    Section,
    showSettingsModal,
    Text,
    TextInput,
    View
} from '../../../common';
import {
    Modal3,
    showLogModal
} from '../../../common/Modal';
import { notifications } from '../../../common/Notifications';
import { MODE } from '../../../config';
import { useRemoteConfigValue } from '../../../hooks/useRemoteConfigValue';
import { useUserInfo } from '../../../hooks/useUserInfo';
import { getFormValues } from '../../../selectors/forms';
import { getLogs } from '../../../selectors/logs';
import { dbGettr } from '../../../selectors/utils';
import {
    FIRST_AID_KIT_KEY,
    FIRST_AID_KIT_SYNC_KEY,
    saveFirstAidKit
} from '../../../services/firstAidKit';
import { storage } from '../../../services/localstorage';
import { MY_DOCUMENTS_SYNC_KEY } from '../../../services/myDocuments';
import store from '../../../store';
import { COLORS } from '../../../styles/colors';
import { getDuplicates } from '../../../utils';
import { aCodeSecurity } from '../../../utils/aCodeSecurity';
import { logTimeFormat } from '../../../utils/dates';
import { stringify } from '../../../utils/log';
import { memoryStorage } from '../../../utils/memoryStorage';
import { CLOUD_CONNECT_REMINDER_STORAGE_KEY } from '../../App/snippets/CloudConnectReminder';
import {
    ImportChildrenButton,
    ImportMyFamilyButton
} from '../../App/snippets/ImportMyFamilyButton';
import {
    ShareChildrenButton,
    ShareFamilyButton
} from '../../App/snippets/ShareFamilyButton';
import {
    FAVORITES_KEY,
    FB_SYNC_KEY,
    PAST_VISITS_KEY
} from '../../App/snippets/Tests&Visits/utils';
import { SwitchWithLabel } from '../../Visits/snippets/NewVisitModal/snippets';
import { toLog } from '../Backup/Backup';
import {
    getBackupHistory,
    getDeletedAttaches,
    removeBackupHistory,
    setLastBackupState
} from '../Backup/common/backupData';
import {
    NEED_SHOW_RESTORE_SCREEN_KEY,
    setNeedShowRestoreScreen
} from '../Backup/common/backupRestore';
import {
    deleteGoogleFile,
    getDevicesData,
    getFiles,
    getGoogleDriveBackupInfo,
    setDeviceData
} from '../Backup/google/googleDrive';
import { icloudFileListShort } from '../Backup/icloud/icloud';
import {
    getDevicesData as getDevicesDataIOS,
    setDevicesData as setDevicesDataIOS
} from '../Backup/icloud/iCloudDevices';
import { getICloudFileListWithSizes } from '../Backup/icloud/iCloudFiles';
import { getAllMetadataFiles } from '../Backup/icloud/iCloudMetadata';
import logger, {
    filterObject,
    sendToTelegram
} from './logger';


export const LogModal = ({
    log,
    onClear,
}) => {
    const [ l, setL ] = useState('');

    const filteredLog = useMemo(() => {
        return filterObject(log, l);
    }, [ log, l ]);

    return <Modal3
        title="Logs"
        onSubmit={() => {
            onClear?.();
            sendToTelegram(filteredLog, [], l);
            Page.closeModal();
        }}
        buttonTitle="В телеграм"
    >
        <View style={{
            marginTop: 32,
            flexDirection: 'row',
            alignItems: 'flex-end',
        }}>
            <Text>Фильтр</Text>
            <TextInput
                label={'Фильтр'}
                value={l}
                onChange={(e) => {
                    setL(e);
                }}
                style={{ flex: 1 }}
            />
        </View>
        <Text selectable>
            {stringify({
                l,
                log: filteredLog,
            }, 7, [
                'visits',
                'family',
                'providerList',
                'relatives',
                'allCards',
                'cards',
                'grants',
                'photoUrl',
                'encryptedData',
                'idToken',
                'accessToken',
            ])}
        </Text>
    </Modal3>;
};

const showLog = (log, onClear = () => {
}) => {
    // eslint-disable-next-line no-undef
    actions.addLog('NEW_ARCHITECTURE', global?.nativeFabricUIManager ? 'Fabric' : 'Paper');
    Page.showModal(<LogModal
        log={log}
        onClear={onClear}/>,
    );
};

const LogButton = () => {
    const dispatch = useDispatch();

    const log = useSelector(getLogs);

    return (
        <BigButton
            title="Логи"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={() => {
                showLog(log, () => dispatch(clearLog()));
            }}
        />
    );
};

const checkBio = async () => {
    try {
        const res = await ReactNativeBiometrics.isSensorAvailable();
        actions.addLog('bio', res);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log('BIO Error', e);
    }
};

const BioButton = () => (
    <BigButton
        title="Биометрия"
        styles={[
            {
                borderWidth: 1,
                borderColor: COLORS.BORDER_GRAY,
                backgroundColor: COLORS.POSITIVE,
                color: COLORS.LIGHT_GRAY,
                padding: 4,
            },
        ]}
        action={() => {
            checkBio();
            showSettingsModal(() => {
            });
        }}
    />
);

const NotifyButton = () => {
    return (
        <BigButton
            title="Список уведомлений"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={() => {
                notifications.getScheduleList((l) =>
                    Page.showModal(
                        <Modal3 title="Notifications list">
                            <Text>
                                {JSON.stringify(
                                    l
                                        .sort((a, b) =>
                                            new Date(a.date).getTime() > new Date(b.date).getTime() ? 1 : -1,
                                        )
                                        .map((item) => ({
                                            id: item.id,
                                            message: item.message,
                                            data: item.data,
                                            date: new Date(item.date).toLocaleString(),
                                        })),
                                    null,
                                    2,
                                )}
                            </Text>
                        </Modal3>,
                    ),
                );
                // Alert.alert('Notifications', JSON.stringify(list));
            }}
        />
    );
};

const GetParam = ({ param }) => {
    const db = useSelector(dbGettr(param, 'UNKNOWN'));
    return (
        <View
            style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
            }}
        >
            <Text>{param}:</Text>
            <Text>{JSON.stringify(db, null, 2)}</Text>
        </View>
    );
};

const OpenRestoreScreen = () => {
    const navigation = useNavigation();
    return (
        <BigButton
            title="Открыть Restore"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={() => {
                navigation.navigate('Account', {
                    screen: 'Restore',
                });
            }}
        />
    );
};

const OpenRemnameScreen = () => {
    const navigation = useNavigation();
    return (
        <BigButton
            title="Открыть Rename IOS backup"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={() => {
                navigation.navigate('Account', {
                    screen: 'IOSBackupRename',
                });
            }}
        />
    );
};

export const ICloudDevices = () => {
    const getDevices = async () => {
        const value = await getDevicesDataIOS();
        showLogModal({
            title: 'iCloud Devices',
            value,
        });
    };
    return Platform.OS === 'ios' ? <BigButton
        title="ICloud Devices"
        styles={[
            {
                borderWidth: 1,
                borderColor: COLORS.BORDER_GRAY,
                backgroundColor: COLORS.POSITIVE,
                color: COLORS.LIGHT_GRAY,
                padding: 4,
            },
        ]}
        action={getDevices}
    /> : null;
};

export const AddICloudDevicesCurrent = () => {
    const add = async () => {
        await setDevicesDataIOS();
    };

    return Platform.OS === 'ios' ? <BigButton
        title="Добавить устройство iCloud"
        styles={[
            {
                borderWidth: 1,
                borderColor: COLORS.BORDER_GRAY,
                backgroundColor: COLORS.POSITIVE,
                color: COLORS.LIGHT_GRAY,
                padding: 4,
            },
        ]}
        action={add}
    /> : null;
};

export const AddGoogleDriveDevices = () => {
    const add = async () => {
        try {
            const data = await setDeviceData();
            showLogModal({
                title: 'Устройства Google Drive',
                value: {
                    message: 'Устройства успешно добавлены',
                    data,
                },
            });
        } catch (e) {
            showLogModal({
                title: 'Ошибка',
                value: `Не удалось добавить устройства Google Drive: ${e.message}`,
            });
        }
    };

    return (
        <BigButton
            title="Добавить устройства Google Drive"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={add}
        />
    );
};

export const DeleteICloudDevices = () => {
    const deleteDevices = async () => {
        await CloudStorage.unlink('devices.json', CloudStorageScope.AppData);
    };

    return Platform.OS === 'ios' ? <BigButton
        title="Удалить устройства iCloud"
        styles={[
            {
                borderWidth: 1,
                borderColor: COLORS.BORDER_GRAY,
                backgroundColor: COLORS.ERROR,
                color: COLORS.LIGHT_GRAY,
                padding: 4,
            },
        ]}
        action={deleteDevices}
    /> : null;
};

export const GoogleDriveDevices = () => {
    const getDevices = async () => {
        const value = await getDevicesData();
        showLogModal({
            title: 'Google Drive Devices',
            value,
        });
    };

    return (
        <BigButton
            title="Google Drive Devices"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={getDevices}
        />
    );
};

export const IsSynced = () => {
    const getDevices = async () => {
        const value = await storage.get(MY_DOCUMENTS_SYNC_KEY);
        showLogModal({
            title: 'isSynced my docs',
            value,
            onClose: () => {
                storage.set(MY_DOCUMENTS_SYNC_KEY, false);
                Page.closeModal();
            },
        });
    };

    return (
        <BigButton
            title="is synced my docs"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={getDevices}
        />
    );
};

export const DeleteGoogleDriveDevices = () => {
    const deleteDevices = async () => {
        const { fileId } = await getDevicesData();
        if (!fileId) {
            showLogModal({
                title: 'Ошибка',
                value: 'Нет файла с устройствами Google Drive',
            });
            return;
        }
        try {
            await deleteGoogleFile(fileId);
        } catch (e) {
            showLogModal({
                title: 'Ошибка',
                value: `Не удалось удалить файл с устройствами Google Drive: ${e.message}`,
            });
        }
    };
    return (
        <BigButton
            title="Удалить устройства Google Drive"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.ERROR,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                } ]
            }
            action={deleteDevices}
        />);
};

export const GoogleBackupInfo = () => {
    const { me } = useUserInfo();
    const profileId = me?.profileId;

    const getFilesInfo = useCallback(async () => {
        if (!profileId) {
            return;
        }
        const info = await getGoogleDriveBackupInfo(profileId, true);
        if (!info) {
            showLogModal({
                title: 'Ошибка',
                value: 'Не удалось получить информацию о бэкапе Google Drive',
            });
            return;
        }
        showLogModal({
            title: 'Google Drive Backup Info',
            value: info,
        });
    }, [ profileId ]);

    return (
        <BigButton
            title="Google Drive бэкапы"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={getFilesInfo}
        />
    );
};

const RemoteConfigButton = () => {
    return (
        <BigButton
            title="Remote config"
            action={async () => {
                Page.showModal(
                    <Modal3 title="Remote config">
                        <View style={{ padding: 10 }}>
                            <Text>
                                PDF storage: {memoryStorage?.size}, now: {memoryStorage.currentSize()}
                            </Text>
                            <GetParam param="defaultSmsProvider"/>
                            <GetParam param="acodeExpirationTime"/>
                            <GetParam param="disableUnconfirmedFeedback"/>
                            <GetParam param="disableUnconfirmedFeedbackForOnlineClinicsOnly"/>
                            <GetParam param="enableLoadPastsVisits"/>
                            <GetParam param="enableReports"/>
                            <GetParam param="enableTests"/>
                            <GetParam param="endOfLife"/>
                            <GetParam param="hideTimePeriodSearch"/>
                            <GetParam param="inAppUpdateAndroid"/>
                            <GetParam param="inAppUpdateIOS"/>
                            <GetParam param="inAppUpdateNotifyPeriod"/>
                            <GetParam param="mapsAppsConfig"/>
                            <GetParam param="showNewUserAgreementModal"/>
                            <GetParam param="statusesOfHappenedVisits"/>
                            <GetParam param="statusesOfHappenedVisitsDoctor"/>
                            <GetParam param="supportedLanguages"/>
                            <GetParam param="popularQueries"/>
                        </View>
                    </Modal3>,
                );
            }}
        />
    );
};

const ScheduleNotification = () => {
    return (
        <BigButton
            title="Нотификация через 15 секунд"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={() => {
                notifications.schedule({
                    date: new Date(Date.now() + 15000),
                    text: 'Test scheduled notify',
                    title: 'Title scheduled notify',
                    message: 'Send feedback',
                    data: {
                        type: 'feedback_reminder1',
                        doctorId: 'no_id',
                    },
                });
            }}
        />
    );
};

const ResetGDReminder = () => (
    <BigButton
        title="Очистить таймер напоминания Google Drive"
        action={async () => {
            await storage.remove(CLOUD_CONNECT_REMINDER_STORAGE_KEY);
        }}
    />
);

const SetShowRestoreScreen = () => {
    const { me } = useUserInfo();
    const onClickHandler = async () => {
        if (!me?.profileId) {
            return;
        }
        const data = await setNeedShowRestoreScreen(true, me?.profileId);
        showLogModal({
            title: 'Флаг Восстановления при логине установлен',
            value: {
                message: `Флаг успешно установлен для профиля ${me.profileId}.`,
                data,
            },
        });
    };

    return (
        <BigButton
            title="Показать скрин восстановления при логине"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={onClickHandler}
        />
    );
};

const RemoveAttachments = () => {
    return (
        <BigButton
            title="Удалить аттачи визитов локально"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.ERROR,
                    color: COLORS.ERROR,
                    padding: 4,
                },
            ]}
            action={async () => {
                const files = await fs.readDir(fs.DocumentDirectoryPath);
                const attachments = files.filter(
                    (file) => file.name.endsWith('.jpg') || file.name.endsWith('.png') || file.name.endsWith('.jpeg'),
                );
                for (const file of attachments) {
                    try {
                        await fs.unlink(file.path);
                    } catch (error) {
                        // console.error(`Error removing attachment ${file.name}:`, error);
                    }
                }
            }}
        />
    );
};

const FBSyncButton = () => (
    <BigButton
        title={'Вкл синк визитов из ФБ (после рестарта)'}
        action={async () => {
            await storage.remove('syncedVersion');
            await storage.remove(PAST_VISITS_KEY);
            await storage.remove(FAVORITES_KEY);
            await storage.remove(FB_SYNC_KEY);
            // storage.getAll().then((res) => {
            //
            //     console.log('RES', res);
            //
            // });
        }}
    />
);

const SetBackupHistory = ({
    state,
    all = true,
}) => {
    return (
        <BigButton
            title={`${all ? 'История бэкапов' : 'Последний бэкап'}: ${state}`}
            styles={[ { backgroundColor: state === 'error' ? COLORS.ERROR : COLORS.POSITIVE } ]}
            action={async () => {
                for (let i = 0; i < (all ? 5 : 1); i++) {
                    await setLastBackupState({
                        state,
                        message: `Test backup history ${i}: ${state}`,
                    });
                }
            }}
        />
    );
};

const RemoveLocalBackupHistory = () => {
    return (
        <BigButton
            title="Удалить локальную историю бэкапов"
            styles={[ { backgroundColor: COLORS.ERROR } ]}
            action={async () => {
                removeBackupHistory();
            }}
        />
    );
};

const ShowLocalBackupHistory = () => {
    return (
        <BigButton
            title="Показать локальную историю бэкапов"
            styles={[ { backgroundColor: COLORS.ERROR } ]}
            action={async () => {
                const history = await getBackupHistory();
                showLogModal({
                    title: 'Локальная история бэкапов',
                    value: history,
                });
            }}
        />
    );
};

const ClearPastVisitsDataButton = () => {
    return (
        <BigButton
            title={'Удалить данные прошлых визитов с устройства'}
            styles={[
                {
                    backgroundColor: COLORS.ERROR,
                    color: COLORS.ERROR,
                },
            ]}
            action={() => {
                storage.set(PAST_VISITS_KEY, null);
            }}
        />
    );
};

const ClearFirstAidKitButton = () => {
    const {
        me: { profileId } = {},
        hashKey,
    } = useUserInfo();
    return (
        <BigButton
            title={'Очистить аптечку текущего профиля'}
            styles={[
                {
                    backgroundColor: COLORS.ERROR,
                    color: COLORS.ERROR,
                },
            ]}
            action={async () => {
                await saveFirstAidKit({
                    profileId,
                    hashKey,
                    basket: [],
                    drugSearch: [],
                });
                await storage.set(FIRST_AID_KIT_KEY, null);
                await actions.reloadUserInfo(
                    Object.handleNewUserItemsFound,
                    actions.updatePrefs,
                    actions.updateSelects,
                );
            }}
        />
    );
};

const ClearFirstAidKitButtonAll = () => {
    return (
        <BigButton
            title={'Очистить аптечку всех профилей'}
            styles={[
                {
                    backgroundColor: COLORS.ERROR,
                    color: COLORS.ERROR,
                },
            ]}
            action={async () => {
                await storage.set(FIRST_AID_KIT_KEY, {});
            }}
        />
    );
};

const ClearFirstAidKitSync = () => {
    return (
        <BigButton
            title={'Включить синк аптечки с ФБ'}
            styles={[
                {
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                },
            ]}
            action={async () => {
                await storage.set(FIRST_AID_KIT_SYNC_KEY, null);
                await actions.reloadUserInfo(
                    Object.handleNewUserItemsFound,
                    actions.updatePrefs,
                    actions.updateSelects,
                );
            }}
        />
    );
};
const showEncryptedModal = async () => {
    const cards = store.getState()?.user?.info?.me?.cards ?? [];

    for (const card of cards) {
        const provider = card?.providerCode;
        if (!provider) {
            return;
        }

        const check = await aCodeSecurity.checkProvider(provider);
        if (check.code) {
            actions.addLog('encrypted', `${provider}: ${check.code} ${logTimeFormat(check.validUntil, false)}`);
        }
    }
};

const EncryptedStorage = () => {
    return (
        <BigButton
            title="А-Коды на шифрованном хранилище -> логи"
            action={async () => {
                await showEncryptedModal();
            }}
        />
    );
};

const ClearAllProfilesVisitsDataButton = () => {
    return (
        <BigButton
            title={'Удалить данные всех профилей с устройства'}
            styles={[
                {
                    backgroundColor: COLORS.ERROR,
                    color: COLORS.ERROR,
                },
            ]}
            action={() => {
                storage.set(FB_SYNC_KEY, null);
            }}
        />
    );
};

export const QAModeButton = () => {
    const dispatch = useDispatch();
    const forms = useSelector(getFormValues);
    return (
        <SwitchWithLabel
            value={forms?.QAMode}
            onValueChange={async () => {
                dispatch(setFormValue('QAMode', !forms?.QAMode));
            }}
            caption={'QA Mode'}
        />
    );
};

const PreformatButton = () => {
    const dispatch = useDispatch();
    const forms = useSelector(getFormValues);
    return (
        <SwitchWithLabel
            value={forms?.Preformat}
            onValueChange={async () => {
                dispatch(setFormValue('Preformat', !forms?.Preformat));
            }}
            caption={'Preformat logs'}
        />
    );
};

const GetBackupInfo = () => {
    const backupFrequency = useRemoteConfigValue('backupFrequency', 86400);
    const [ history, setHistory ] = useState([]);

    const style = {
        color: COLORS.STANDARD_GRAY,
        fontSize: 10,
        textAlign: 'center',
        padding: 3,
    };

    useFocusEffect(
        useCallback(() => {
            getBackupHistory()
                .then((h) => {
                    setHistory(h);
                })
                .catch(() => {
                    // console.error('Error getting backup history:', e);
                });
        }, []),
    );

    const lastBackup = useMemo(() => {
        return history?.[0]?.date ?? null;
    }, [ history ]);

    const f = useCallback((dt) => {
        return format(toDate(dt), 'dd.MM.yy HH:mm');
    }, []);

    try {
        return lastBackup ? (
            <Text style={style}>
                Last backup check: {f(lastBackup)}, next: {f(lastBackup + backupFrequency * 1000)}
            </Text>
        ) : (
            <Text style={style}>Mo backups</Text>
        );
    } catch (e) {
        return <Text>Error getting backup info</Text>;
    }
};

export const UnlinkICloudFiles = () => {
    const { me } = useUserInfo();

    const getFilesInfo = useCallback(async () => {
        const profileId = me?.profileId;
        if (!profileId) {
            return;
        }
        const files = await getICloudFileListWithSizes();
        toLog('UnlinkICloudFiles: files', files);
        // showLogModal({
        //     title: 'iCloud файлы',
        //     value: files,
        // });
        return files;
    }, [ me?.profileId ]);

    const unlinkFiles = useCallback(async () => {
        const files = await getFilesInfo();
        if (!files?.length) {
            return;
        }
        for (const file of files) {
            let fileName = file.file;
            if (fileName.endsWith('.icloud')) {
                fileName = fileName.slice(0, -7);
            }
            const localPath = `${fs.DocumentDirectoryPath}/${fileName}`;
            try {
                const exists = await fs.exists(localPath);
                if (exists) {
                    await fs.unlink(localPath);
                }
            } catch (error) {
                console.error(`Error removing local iCloud file copy ${localPath}:`, error);
            }
        }
        const list = await CloudStorage.readdir('/');
        console.log('iCloud files after local unlink:', list);
    }, [ getFilesInfo ]);

    return (
        <BigButton
            title="Unlink iCloud files"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.ERROR,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={unlinkFiles}
        />
    );
};

const LotToTelegram = () => {
    const logs = logger.getLogs();

    return (
        <BigButton
            title="Отправить логи в телегу"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={async () => {
                console.log('Sending logs to Telegram:', {
                    logs,
                    text: JSON.stringify(logs),
                });
                logger.sendToTelegram()
                    .catch((err) => {
                        console.error('Error sending logs to Telegram:', err);
                        showLogModal({
                            title: 'Ошибка отправки логов в телегу',
                            value: `Ошибка: ${err.message}`,
                        });
                    })
                    .then(() => {
                        showLogModal({
                            title: 'Логи отправлены в телегу',
                            value: 'Проверьте ваш чат с ботом.',
                        });
                    });
            }}
        />
    );
};

const ShowICloudMetadata = () => {

    const showMetadataHandler = useCallback(async () => {

        const metadata = await getAllMetadataFiles();
        if (!metadata || !Object.keys(metadata).length) {
            showLogModal({
                title: 'Ошибка',
                value: 'Нет метаданных в iCloud',
            });
            return;
        }
        showLogModal({
            title: 'iCloud Metadata',
            value: metadata,
            pre: false,
        });
    }
    , []);
    return (
        <BigButton
            title="Показать метаданные iCloud"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={showMetadataHandler}
        />
    );
};

export const ClearNeedRestoreScreen = () => {
    const { me } = useUserInfo();
    const onClickHandler = async () => {
        if (!me?.profileId) {
            return;
        }
        const data = await setNeedShowRestoreScreen(true, me?.profileId);
        showLogModal({
            title: 'Флаг Восстановления при логине очищен',
            value: {
                message: `Флаг успешно очищен для профиля ${me.profileId}.`,
                data,
            },
        });
    };

    return (
        <BigButton
            title="Очистить флаг Восстановления при логине"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={onClickHandler}
        />
    );
};

export const ShowNeedRestoreScreen = () => {
    const { me } = useUserInfo();
    const onClickHandler = async () => {
        toLog('ShowNeedRestoreScreen: me', me);
        const data = await storage.getObject(NEED_SHOW_RESTORE_SCREEN_KEY, {});
        showLogModal({
            title: 'Флаг Восстановления при логине',
            value: {
                message: `Флаг для профиля ${me?.profileId} установлен в ${data?.[me?.profileId]}.`,
                data,
            },
            pre: false,
        });
    };
    return (
        <BigButton
            title="Показать флаг Восстановления при логине"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={onClickHandler}
        />);
};

export const LocalFiles = ({ path = '' }) => {
    const getFiles = useCallback(async () => {
        try {
            return await fs.readDir(fs.DocumentDirectoryPath + path);
        } catch (error) {
            console.error('Error reading local files:', error);
            return [];
        }
    }, []);

    return (
        <BigButton
            title={`Показать локальные файлы ${path}`}
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={async () => {
                const files = await getFiles();
                if (files.length === 0) {
                    showLogModal({
                        title: 'Локальные файлы',
                        value: 'Нет локальных файлов',
                    });
                    return;
                }
                const fileList = files.map((file) => ({
                    path: file.path,
                    name: file.name,
                    size: file.size,
                }));
                showLogModal({
                    title: 'Локальные файлы',
                    value: fileList,
                });
            }}
        />
    );
};
export const CacheFiles = ({ path = '' }) => {
    const getFiles = useCallback(async () => {
        try {
            return await fs.readDir(fs.CachesDirectoryPath + path);
        } catch (error) {
            console.error('Error reading local files:', error);
            return [];
        }
    }, []);

    return (
        <BigButton
            title={`Показать файлы Cache ${path}`}
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={async () => {
                const files = await getFiles();
                if (files.length === 0) {
                    showLogModal({
                        title: 'Локальные файлы Cache',
                        value: 'Нет локальных файлов',
                    });
                    return;
                }
                const fileList = files.map((file) => ({
                    path: file.path,
                    name: file.name,
                    size: file.size,
                }));
                showLogModal({
                    title: 'Локальные файлы',
                    value: fileList,
                });
            }}
        />
    );
};

export const DebugScreen = Page.register(() => {
    return (
        (MODE === 'qa' || LOG_TO_RELEASE) && (
            <Page scroll>
                <View style={{ margin: 10 }}>
                    <QAModeButton/>
                    <PreformatButton/>
                    <TestDuplicates/>
                    <LogButton/>
                    <LotToTelegram/>
                    <RemoteConfigButton/>
                    <Section
                        title={'Нотификации'}
                        style={{ paddingHorizontal: 0 }}
                    >
                        <NotifyButton/>
                        <ScheduleNotification/>
                    </Section>
                    <BioButton/>
                    <Section
                        title={'Семья'}
                        style={{ paddingHorizontal: 0 }}
                    >
                        <ShareFamilyButton/>
                        <ShareChildrenButton/>
                        <ImportMyFamilyButton/>
                        <ImportChildrenButton/>
                    </Section>
                    <Section
                        title={'Бэкап'}
                        style={{ paddingHorizontal: 0 }}
                    >
                        <OpenRestoreScreen/>
                        <OpenRemnameScreen/>
                        <SetShowRestoreScreen/>
                        <ResetGDReminder/>
                        <RemoveAttachments/>
                        <ShowLocalBackupHistory/>
                        <SetBackupHistory state={'success'}/>
                        <SetBackupHistory state={'error'}/>
                        <SetBackupHistory
                            state={'success'}
                            all={false}
                        />
                        <SetBackupHistory
                            state={'error'}
                            all={false}
                        />
                        <RemoveLocalBackupHistory/>
                        <ShowGoogleDrive/>
                        <ShowICloud/>
                        <UnlinkICloudFiles/>
                        <GoogleDriveDevices/>
                        <ICloudDevices/>
                        <AddGoogleDriveDevices/>
                        <AddICloudDevicesCurrent/>
                        <ShowICloudMetadata/>
                        <DeleteGoogleDriveDevices/>
                        <DeleteICloudDevices/>
                        <GetBackupInfo/>
                        <GoogleBackupInfo/>
                        <ShowNeedRestoreScreen/>
                        <ClearNeedRestoreScreen/>
                        <LocalFiles/>
                        <LocalFiles path={'/storage'}/>
                        <CacheFiles/>
                        <DeletedAttachesList/>
                        <IsSynced/>
                    </Section>
                    <Section
                        title={'Визиты'}
                        style={{ paddingHorizontal: 0 }}
                    >
                        <FBSyncButton/>
                        <ClearPastVisitsDataButton/>
                        <ClearAllProfilesVisitsDataButton/>
                    </Section>
                    <Section
                        title={'Прочее'}
                        style={{ paddingHorizontal: 0 }}
                    >
                        <EncryptedStorage/>
                    </Section>
                    <Section
                        title={'Аптечка'}
                        style={{ paddingHorizontal: 0 }}
                    >
                        <ClearFirstAidKitButton/>
                        <ClearFirstAidKitButtonAll/>
                        <ClearFirstAidKitSync/>
                    </Section>
                    <Section
                        title={'Диплинки'}
                        style={{ paddingHorizontal: 0 }}
                    >
                        <ResetReferrerFlagButton/>
                    </Section>
                </View>
            </Page>
        )
    );
});

const ResetReferrerFlagButton = () => {
    return (
        <BigButton
            title="Сброс Referrer Flag"
            action={async () => {
                await storage.remove('referrerChecked');
                notifications.show({
                    type: 'success',
                    title: 'Флаг сброшен',
                    message: 'Теперь install referrer будет проверяться заново',
                });
                actions.addLog('deeplink', 'Referrer flag reset - next app start will check install referrer');
            }}
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.WARNING,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
        />
    );
};

const DeletedAttachesList = () => {
    return <BigButton
        title="Список удаленных аттачей"
        action={async () => {
            const list = await getDeletedAttaches();
            showLogModal({
                title: 'Удаленные аттачи',
                value: list,
            });
        }}
        styles={[
            {
                borderWidth: 1,
                borderColor: COLORS.BORDER_GRAY,
                backgroundColor: COLORS.WARNING,
                color: COLORS.LIGHT_GRAY,
                padding: 4,
            },
        ]}
    />;
};

const ShowGoogleDrive = () => {
    const { me } = useUserInfo();
    const getFilesInfo = useCallback(async () => {
        const profileId = me?.profileId;
        if (!profileId) {
            return;
        }
        const {
            files,
        } = await getFiles(profileId);
        showLogModal({
            title: 'Google Drive файлы',
            value:
            files,
            pre: true,
        });
    }, [ me?.profileId ]);
    return (
        <BigButton
            title="Google Drive файлы"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={getFilesInfo}
        />
    );
};
const TestDuplicates = () => {
    const files = [
        {
            'id': '1qDju_-Y1z5Sjw30tNgeKDUfqzEklkIBIXpzON4YeHHc5kdSghA',
            'name': 'aimdbackup_5eb5fc1a6937fccc_6888b2db6487de5f88b79b07.json',
            'createdTime': '2025-09-30T10:50:56.722Z',
            'size': '7596',
        },
        {
            'id': '1ToE6hh86gtllcoyhhb0eCgXjF5OKdQrAm49v3KynqW7ppKawcw',
            'name': 'attach_6888b2db6487de5f88b79b07_rn_image_picker_lib_temp_6711e5ad-52aa-4aae-bbca-730b54c5d2ff.jpg',
            'createdTime': '2025-09-30T10:50:59.523Z',
            'size': '63628',
        },
        {
            'id': '1p-uZ-0lAIy-5Sdoy_QDDKUpulFmzHbJ3upVx4NG3KQnOeVMApA',
            'name': 'attach_6888b2db6487de5f88b79b07_rn_image_picker_lib_temp_325044ca-f33f-4ea4-8075-bfde907caaa2.jpg',
            'createdTime': '2025-09-30T10:50:59.431Z',
            'size': '185284',
        },
        {
            'id': '198K17_VawiigT5DdUSHh-0Gf_6yVpjETb9MSZQyPUbBbnXTsCQ',
            'name': 'attach_6888b2db6487de5f88b79b07_rn_image_picker_lib_temp_f5b163f7-018b-4ffd-b457-113fc786a11f.jpg',
            'createdTime': '2025-09-30T10:50:59.136Z',
            'size': '116332',
        },
        {
            'id': '11jl8ZDYemd4wzlFWyuNNwlS-qaoUbqe6bTC__MX4TPyRzGJIhw',
            'name': 'devices.json',
            'createdTime': '2025-09-30T10:50:54.236Z',
            'size': '264',
        },
        {
            'id': '1upxb0Q78F8WCcrDExiWpsUxBijtfNzf7IH_rC5sRhHqgOKUDxg',
            'name': 'attach_6888b2db6487de5f88b79b07_rn_image_picker_lib_temp_ef33f5a8-e138-4f12-84b3-49cfbe0dcacf.jpg',
            'createdTime': '2025-09-30T10:44:10.108Z',
            'size': '185284',
        },
        {
            'id': '17oOCQZB0l8klUEnC2LX37WrNq8P0izobrZReFyoAjMFrEHmEhQ',
            'name': 'attach_6888b2db6487de5f88b79b07_rn_image_picker_lib_temp_ae8c18ce-d624-4667-aae5-8d97c14e54ac.jpg',
            'createdTime': '2025-09-30T10:44:10.097Z',
            'size': '196974',
        },
        {
            'id': '1WLhYXLSa9OQrAXDcMJKgMYz4PRxSQ058P9YDSsOyXQlGt4LpPg',
            'name': 'attach_6888b2db6487de5f88b79b07_rn_image_picker_lib_temp_21cf2027-1789-4490-8bb6-0ebcb4e1f8b2.jpg',
            'createdTime': '2025-09-30T10:44:09.987Z',
            'size': '116332',
        },
        {
            'id': '1dN-ZzcDU9AdWqTcd-HjDKyQAkX6WKRF0-FvV0SaSlPwHX8ltww',
            'name': 'aimdbackup_85FA39BC-6A99-4918-86D5-CBF21B1806E7_6888b2db6487de5f88b79b07.json',
            'createdTime': '2025-09-30T08:15:16.591Z',
            'size': '4356',
        },
        {
            'id': '1d-ZzcDU9AdWqTcd-HjDKyQAkX6WKRF0-FvV0SaSlPwHX8ltww',
            'name': 'aimdbackup_85FA39BC-6A99-4918-86D5-CBF21B1806E7_6888b2db6487de5f88b79b07.json',
            'createdTime': '2025-09-30T08:15:16.591Z',
            'size': '4356',
        },
        {
            'id': '1yaL-81zecdtleDB9focpl1_UxLeqI7mpo4cqa3T-OKiSX5RCSg',
            'name': 'attach_6888b2db6487de5f88b79b07_rn_image_picker_lib_temp_fe6d820b-e82a-42c4-8e80-35da233eb424.jpg',
            'createdTime': '2025-09-30T07:08:51.632Z',
            'size': '63628',
        },
    ];

    const dup = getDuplicates(files, 'name');

    const getFilesInfo = useCallback(async () => {
        showLogModal({
            title: 'Duplicates',
            value: {
                files,
                dup,
            },
            pre: true,
        });
    }, [ dup, files ]);
    return (
        <BigButton
            title="Test Duplicates"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={getFilesInfo}
        />
    );
};

const ShowICloud = () => {
    const { me } = useUserInfo();
    const getFilesInfo = useCallback(async () => {
        const profileId = me?.profileId;
        if (!profileId) {
            return;
        }
        const files = await getICloudFileListWithSizes();
        try {
            showLogModal({
                title: 'iCloud файлы',
                value: icloudFileListShort(files, true),
            });
        } catch (e) {
            //
        }
    }, [ me?.profileId ]);
    return (
        <BigButton
            title="iCloud файлы"
            styles={[
                {
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    backgroundColor: COLORS.POSITIVE,
                    color: COLORS.LIGHT_GRAY,
                    padding: 4,
                },
            ]}
            action={getFilesInfo}
        />
    );
};

export const DebugButton = ({ hide }) => {
    const navigation = useNavigation();
    return (
        (MODE === 'qa' || LOG_TO_RELEASE) &&
        !hide && (
            <BigButton
                title="Отладочная информация"
                styles={[
                    {
                        borderWidth: 1,
                        borderColor: COLORS.BORDER_GRAY,
                        backgroundColor: COLORS.POSITIVE,
                        color: COLORS.LIGHT_GRAY,
                        padding: 4,
                    },
                ]}
                action={() => {
                    navigation.navigate('DebugScreen');
                }}
            />
        )
    );
};
